import {IOpeningTime, IOpeningTimesPayload} from "../interfaces/openingtimes";
export class OpeningTimes {
  public monday: IOpeningTime[];
  public tuesday: IOpeningTime[];
  public wednesday: IOpeningTime[];
  public thursday: IOpeningTime[];
  public friday: IOpeningTime[];
  public saturday: IOpeningTime[];
  public sunday: IOpeningTime[];

  constructor (payload: IOpeningTimesPayload) {
    this.monday = payload.Monday;
    this.tuesday = payload.Tuesday;
    this.wednesday = payload.Wednesday;
    this.thursday = payload.Thursday;
    this.friday = payload.Friday;
    this.saturday = payload.Saturday;
    this.sunday = payload.Sunday;
  }
}



// WEBPACK FOOTER //
// ./src/app/classes/openingtimes.ts